import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class BiddingEnterpriseApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'bidding-enterprise'
    }


 

}